import { render, staticRenderFns } from "./lianjie.vue?vue&type=template&id=7f56af80&scoped=true"
import script from "./lianjie.vue?vue&type=script&lang=ts"
export * from "./lianjie.vue?vue&type=script&lang=ts"
import style0 from "./lianjie.vue?vue&type=style&index=0&id=7f56af80&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f56af80",
  null
  
)

export default component.exports